var p = { exports: {} };
export {
  p
};
//# sourceMappingURL=index3.js.map
